import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import EventNoteIcon from '@mui/icons-material/EventNote'
import PendingActionsIcon from '@mui/icons-material/PendingActions'
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek'
import GroupsIcon from '@mui/icons-material/Groups'
import InsightsIcon from '@mui/icons-material/Insights'

export const MENTOR_CLINIC_BOOKING_TABS = {
  calendar: {
    id: 'calendar',
    title: 'Calendar',
    description: 'Day view of booked slots',
    icon: CalendarMonthIcon,
    roleType: ['ROLE_THERAPIST', 'ROLE_DOCTOR', 'ROLE_CLINIC_ASSISTANT'],
  },
  appointments: {
    id: 'appointments',
    title: 'Appointments',
    description: 'All appointments as a list',
    icon: EventNoteIcon,
    roleType: ['ROLE_THERAPIST', 'ROLE_DOCTOR', 'ROLE_CLINIC_ASSISTANT'],
  },
  planned: {
    id: 'planned',
    title: 'Planned',
    description: 'Upcoming planned sessions',
    icon: PendingActionsIcon,
    roleType: ['ROLE_THERAPIST', 'ROLE_DOCTOR'],
  },
  roster: {
    id: 'roster',
    title: 'My Roster',
    description: 'Your weekly roster',
    icon: CalendarViewWeekIcon,
    roleType: ['ROLE_THERAPIST'],
  },
  patients: {
    id: 'patients',
    title: 'Patients',
    description: 'Search & manage patients',
    icon: GroupsIcon,
    roleType: ['ROLE_CLINIC_ASSISTANT'],
  },
  // Full-page Patients surface for the doctor/therapist mentor flow. Selecting it renders the
  // patient search/add content full-page in the content area (see MentorClinicBookingsPage) rather
  // than driving the shared DayViewCalendarComponent, so it intentionally uses a distinct id.
  patientsPage: {
    id: 'patientsPage',
    title: 'Patients',
    description: 'Search & manage patients',
    icon: GroupsIcon,
    roleType: ['ROLE_THERAPIST', 'ROLE_DOCTOR'],
  },
  // Full-page Stats surface for this clinic location (renders ClinicLocationStatsDrawer inline,
  // scoped to the checked-in clinic). See MentorClinicBookingsPage.
  statsPage: {
    id: 'statsPage',
    title: 'Stats',
    description: 'Statistics for this clinic',
    icon: InsightsIcon,
    roleType: ['ROLE_THERAPIST', 'ROLE_DOCTOR'],
  },
}

export const MENTOR_CLINIC_BOOKING_TABS_LIST = Object.values(MENTOR_CLINIC_BOOKING_TABS)
